import React, { useEffect } from 'react';
import TextArea from '../Reutilizaveis/TextArea';
import { Typography } from '@material-ui/core';

export default function Comment({ value, setValue, disabled, title }) {
  const handleOnChange = (e) => {
    value = e.target.value;
    setValue(value);
  };

  useEffect(() => {
    return () => {
      setValue('');
    };
  }, []);

  return (
    <>
      {title && (
        <Typography
          style={{ marginBottom: 8, fontWeight: 'bold' }}
          variant='body2'
          color='initial'
        >
          {title}
        </Typography>
      )}

      <TextArea
        maxLength={255}
        value={value}
        onChange={handleOnChange}
        minRows={3}
        disabled={disabled}
      />
    </>
  );
}
